<template>
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8 4.4A1.2 1.2 0 1 0 8 2a1.2 1.2 0 0 0 0 2.4ZM8 9.2A1.2 1.2 0 1 0 8 6.8a1.2 1.2 0 0 0 0 2.4ZM9.2 12.8A1.2 1.2 0 1 1 6.8 12.8a1.2 1.2 0 0 1 2.4 0Z"
    fill="currentColor" />
</template>
